module.exports = __webpack_public_path__ + "img/jobInterview.2f13f5ff.svg";